var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.78125,
    width: 104.219,
    height: 104.219,
    rx: 9.8016,
    fill: "#231671",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.211 27.9452H73.372C75.006 27.9452 76.5731 28.5943 77.7285 29.7497C78.8839 30.9051 79.533 32.4722 79.533 34.1062V77.2332C79.533 78.8672 78.8839 80.4343 77.7285 81.5897C76.5731 82.7451 75.006 83.3942 73.372 83.3942H30.245C28.611 83.3942 27.0439 82.7451 25.8885 81.5897C24.7331 80.4343 24.084 78.8672 24.084 77.2332V34.1062C24.084 30.7176 26.8564 27.9452 30.245 27.9452H36.406V21.7842H42.567V27.9452H61.05V21.7842H67.211V27.9452ZM30.245 40.2672V77.2332H73.372V40.2672H30.245ZM48.728 55.6697V49.5087H54.889V55.6697H61.05V61.8307H54.889V67.9917H48.728V61.8307H42.567V55.6697H48.728Z",
    fill: "#231671"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.6101,
    height: 61.6101,
    fill: "white",
    transform: "translate(21.0039 21.7832)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date_icon.3fe73a4b6c7bb3ec524e25e701be0a9e.svg";
export { ForwardRef as ReactComponent };